<template>
  <div>
    <div class="content">
      <div class="content-main">
        <div>
          <div style="margin-bottom: 8px; display: flex;  justify-content: space-between;">
            <el-space>
              <p class="content-title"><span>配置特定注册时间：</span><span style="font-weight: normal" v-if="!changDate">{{limitDate}}</span></p>
              <el-date-picker v-if="changDate" v-model="limitDate" type="date" placeholder="Pick a day" size="default" value-format="YYYY-MM-DD" style="width: 12em"/>
              <el-button size="default" v-if="!changDate" type="primary" @click="changDate = true">修改时间</el-button>
              <el-button size="default" v-if="changDate" type="primary" @click="submitDate('limitDate', limitDate)">确定</el-button>
              <el-button size="default" v-if="changDate" @click="canceDate">取消</el-button>
            </el-space>
            <ElIcons @click="getPage" :size="18" name="Refresh" class="icon-btn"/>
          </div>
          <p style="color: #aaaaaa"><span style="color: red">* </span>注册时间晚于配置时间的用户，为需要执行邀请制的用户</p>
        </div>
        <el-divider border-style="dashed" />
        <div style="margin-bottom: 8px">
          <el-space>
            <p class="content-title"><span>配置特定性别：</span><span style="font-weight: normal" v-if="!changSex">{{sex == 0?'全部':sex == 1?'男生': sex==2?'女生':''}}</span></p>
            <el-select v-model="sex" placeholder="Select" style="width: 8em" v-if="changSex">
              <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button size="default" v-if="!changSex" type="primary" @click="changSex = true">编辑</el-button>
            <el-button size="default" v-if="changSex" type="primary" @click="submitSex('sex', sex)">确定</el-button>
            <el-button size="default" v-if="changSex" @click="canceSex">取消</el-button>
          </el-space>
        </div>

        <el-divider border-style="dashed" />
        <div style="display: flex; align-items: center">
          <p class="content-title" >配置特定城市：</p>
          <div style="display: flex;">
            <Area v-if="showArea" title="" @areaChang='getArea($event)'/>
            <ElButtons icon="Plus" v-else @click="showArea = true">添加城市</ElButtons>
<!--            <el-checkbox class="check" v-model="checkArea" @change="noArea()" style="margin-left: 12px;">不限城市</el-checkbox>-->
          </div>
        </div>
        <div class="content-table" style="padding: 16px 0 0">
          <div style="display: flex; flex-wrap: wrap; align-items: center;">
            <el-tag v-for="(name, index) in selectCitys" size="large" :key="name" closable type="info" @close="delCity(index)" style="margin: 0 8px 8px 0">{{ name }}</el-tag>
          </div>
        </div>
        <el-divider border-style="dashed" />
        <div style="background-color: #f6f6f6; padding: 32px; border-radius: 16px">

          <div style="display: flex; align-items: center">
            <p class="content-title" style="margin-right: 4px">企业微信获客链接是否启用：</p>
            <el-switch style="margin-left: 12px" v-model="wechatSkipShow" active-text="开" inactive-text="关" @change="submitSex('wechatSkipShow', wechatSkipShow?1:0)"/>
          </div>
          <p style="color: #aaaaaa"><span style="color: red">* </span>启用时则直接跳转添加微信，停用则跳转企微二维码</p>
          <el-divider border-style="dashed" />

          <p class="content-title" style="margin-right: 12px">配置企业获客链接</p>
          <el-space>
            <p v-if="!changePath">{{wechatSkipPath}}</p>
            <el-input type="text" v-model="wechatSkipPath" v-if="changePath" style="width: 30em"/>
            <el-button size="default" v-if="!changePath" type="primary" @click="changePath = true">编辑</el-button>
            <el-button size="default" v-if="changePath" type="primary" @click="submitSex('wechatSkipPath', wechatSkipPath)">确定</el-button>
            <el-button size="default" v-if="changePath" @click="canceChangePath">取消</el-button>
          </el-space>
          <el-divider border-style="dashed" />

          <div>
            <div style="display: flex; align-items: center; margin-bottom: 12px">
              <p class="content-title" style="margin-right: 12px">配置微信二维码</p>
              <el-button size="default"  type="primary" @click="changImg">编辑</el-button>
            </div>
            <el-image style="height: 80px; width: 80px" :src="wechatCodeImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { getHomeRecommendCoeff, updateCoeffList } from '../../api/url'
import { postFormData, getFormData } from "@/api/api";
import {positiveIntReg} from "@/assets/shared/reg-constant";
import Area from '@/components/AreaSelect'
import Dialog from "@/assets/js/dialog";
import ImgUpload from "@/views/setting/components/ImgUpload";

export default {
name: "InvitationParam",
  components: { Area },
  data() {
    return {
      loading: false,
      filterProAndCityList: [],

      limitDate: '',//注册时间
      limitDateOld: '',
      changDate: false,

      sex: '',//性别
      sexArray: [
        { label: '全部', value: '0'},
        { label: '男生', value: '1'},
        { label: '女生', value: '2'},
      ],
      sexOld: '',
      changSex: false,

      wechatCodeImg: '',
      wechatCode: '',

      // 城市
      checkArea: false,
      showArea: false,
      homeProvince: '',
      homeCity: '',
      selectCitys: [],
      selectProvinces: [],
      areaList: [],


      wechatSkipPath: '',
      wechatSkipPathOld: '',
      changePath: false,
      wechatSkipShow: '',
    }
  },
  methods: {

    // 现居城市
    getArea(el) {
      // console.log(el)
      this.homeProvince = el.prov;
      this.homeCity = el.city;
      if(this.homeCity != '' && this.homeCity != null && this.homeCity != '不限'){
        let c = this.selectCitys.indexOf(this.homeCity);
        if(c == -1){
          this.selectCitys.push(this.homeCity)
          this.submitCity()
        }else{
          this.$message({
            message: '你已经添加了改城市',
            type: "error"
          });
        }
      }
    },


    delCity(index){
      this.selectCitys.splice(index,1);
      this.submitCity()
    },

    noArea(){
      this.selectCitys = [];
      this.citys = '全国'
      this.showArea = false
      this.resetArea = !this.resetArea;
      if(this.checkArea) {
        this.submitCity()
      }
    },

    changImg() {
      Dialog.open({
        title: '配置微信二维码',
        component: ImgUpload,
        data: {
          src: this.wechatCodeImg,
          width: '400px',
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    // objectSpanMethodOne({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0) {
    //     if (rowIndex % 2 === 0) {
    //       return {
    //         rowspan: 2,
    //         colspan: 1
    //       };
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0
    //       };
    //     }
    //   }
    // },
    //
    // objectSpanMethodTwo({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0) {
    //     if (rowIndex == 0 || rowIndex == 2 || rowIndex == 11 || rowIndex == 13 || rowIndex == 15) {
    //       return {
    //         rowspan: 2,
    //         colspan: 1
    //       };
    //     }else if (rowIndex == 4) {
    //       return {
    //         rowspan: 7,
    //         colspan: 1
    //       };
    //     }else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0
    //       };
    //     }
    //   }
    // },

    getPage() {
      this.loading = true;
      getFormData(getHomeRecommendCoeff, {id: 4}).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          let dataList = data.data
          let content = JSON.parse(dataList.content)
          this.selectCitys = content.filterProAndCityList
          this.limitDate = content.limitDate
          this.limitDateOld = content.limitDate
          this.sex = content.sex
          this.sexOld = content.sex
          this.wechatCodeImg = content.wechatCodeImg
          this.wechatSkipPath = content.wechatSkipPath
          this.wechatSkipPathOld = content.wechatSkipPath
          this.wechatSkipShow = content.wechatSkipShow == 1?true:false
          // if(this.selectCitys.length == 0) {
          //   this.checkArea = true
          // }
          // console.log(content)
          // this.paramList.map(param => {
          //   for(let i=0; i < param.length; i++) {
          //     for(let j in param[i]) {
          //       let s = (param[i].sex == 1?'M':'F')
          //       if(dataList.content.indexOf(param[i].label + j + s) > -1) {
          //         param[i]['key_' + param[i].label + j + s]= param[i].label + j + s
          //         param[i][param[i].label + j + s] = content[param[i].label + j + s]
          //       }
          //     }
          //   }
          // })
          // this.paramList[0].map(item => {
          //   for(let k in item) {
          //     if(k == 'LoveRate') {
          //       let s = (item.sex == 1?'M':'F')
          //       if(item.label == 'margin') {
          //         item[item.label + 'LoveRateMin' + s] = item[item.label + 'LoveRate' +s]
          //         item['key_' + item.label + 'LoveRateMin' + s] = item['key_' + item.label + 'LoveRate' +s]
          //       }else {
          //         item[item.label + 'LoveRateMax' + s] = item[item.label + 'LoveRate' +s]
          //         item['key_' + item.label + 'LoveRateMax' + s] = item['key_' + item.label + 'LoveRate' +s]
          //       }
          //     }
          //   }
          // })
          // this.paramList[1].map(item => {
          //   for(let k in item) {
          //     if(k == 'NumMax') {
          //       let s = (item.sex == 1?'M':'F')
          //       item[item.label + 'Num' +s] = item[item.label + 'NumMax' +s]
          //       item['key_' + item.label + 'Num' +s] = item['key_' + item.label + 'NumMax' +s]
          //     }
          //   }
          // })
          // console.log(this.paramList)
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 200
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },


    submitCity() {
      let param = {}
      param['id'] = 4;
      param['key'] = 'filterProAndCityList'
      if(this.selectCitys.length > 0) {
        param['filterProAndCityList'] = this.selectCitys
      }else {
        param['filterProAndCityList'] = ''
      }
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    canceDate() {
      this.limitDate = this.limitDateOld
      this.changDate = false
    },

    canceSex() {
      this.sex = this.sexOld
      this.changSex = false
    },

    canceChangePath() {
      this.wechatSkipPath = this.wechatSkipPathOld
      this.changePath = false
    },

    submitDate(key, value) {
      if(!value) {
        this.$message({
          message: '输入不能为空',
          type: 'warning',
          duration: 2000
        })
        return false
      }
      let param = {}
      param['id'] = 4;
      param['key'] = key
      param[key] = value
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
          this.changDate = false
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },


    submitSex(key, value) {
      let param = {}
      param['id'] = 4;
      param['key'] = key
      param['value'] = value
      postFormData(updateCoeffList, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          this.getPage()
          this.changSex = false
          this.changePath = false
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    // showEdit(row, showLabel) {
    //   this.paramList.map(item => {
    //     item.map(p => {
    //       for(let s in p){
    //         // console.log(s)
    //         if(s.indexOf('show') > -1) {
    //           p[s] = false
    //         }
    //       }
    //     })
    //   })
    //   row['show_' + showLabel] = true
    // },

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
}
.edit-btn {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
}
.edit-btn:hover {
  background-color: #6fb6ff;
  color: #ffffff;
}
p {
  cursor: pointer;
}

.content-title {
  cursor: text;
}

.icon-btn {
  padding: 4px;
  margin-left: 16px;
  cursor: pointer;
}

.icon-btn:hover {
  color: #409eff;
}
</style>
